import { render } from "./SoftwareProjects.vue?vue&type=template&id=abe44028&ts=true"
import script from "./SoftwareProjects.vue?vue&type=script&lang=ts"
export * from "./SoftwareProjects.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__